import { render, staticRenderFns } from "./section-categories.vue?vue&type=template&id=206f9756&scoped=true&"
import script from "./section-categories.vue?vue&type=script&lang=js&"
export * from "./section-categories.vue?vue&type=script&lang=js&"
import style0 from "./section-categories.vue?vue&type=style&index=0&id=206f9756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f9756",
  null
  
)

export default component.exports